import React from "react";
import { useNetworkStatus } from "../hooks/useNetworkStatus";

const OfflineIndicator = ({ className }) => {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className={className}>
      <span style={{ color: "#b45309", fontSize: "12px", fontWeight: 500 }}>
        Offline
      </span>
    </div>
  );
};

export default OfflineIndicator;
